import { h, ref } from 'vue'
import type { ColumnDef } from '@tanstack/vue-table'
import { ArrowUpDown, ChevronDown } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem
} from '@/components/ui/select';
import { Calendar } from '@/components/ui/calendar'
import { update_server, formatForDateInput } from '@/utils/globals';

export interface Project {
  id: number;
  name: string;
  description: string;
  status: number;
  start: Date;
  end: Date;
  periods?: { start: string, end: string }[];
  color: string
}


const projectStatusOptions = [{id: 0, label: 'Aktiv'}, {id: 1, label: 'Inaktiv'}, {id: 2, label: 'Potentiell'}];


export const colsproject = [
{ key: "id", label: "ID", editable: false },
{ key: "name", label: "Name", editable: true, required: true, width: 80 },
{ key: "description", label: "Beschreibung", type: 'textarea', editable: true, required: true, width: 100 },
{ key: "status", label: "Status", type: 'select', options: projectStatusOptions, editable: true, required: true },
// start/end sind seit TIM-38 abgeleitete Werte - die aeussere Klammer ueber die
// Abschnitte. Sie werden nur noch angezeigt; geaendert wird ueber "Zeitraeume",
// weil zwei Felder eine Liste von Abschnitten nicht abbilden koennen.
// Beim Anlegen gibt es noch keine Abschnitte - dann sind sie der erste (TIM-81/1).
{ key: "start", label: "Start", type: 'date', editable: false, editableOnCreate: true, required: false },
{ key: "end", label: "Ende", type: 'date', editable: false, editableOnCreate: true, required: false },
{ key: "periods", label: "Zeiträume", type: 'periods', editable: true, required: false },
{ key: "color", label: "Farbe", type: 'color', editable: true, required: true },
{ key: "created_at", label: "Erzeugt", type: 'date', editable: false, required: false },
{ key: "updated_at", label: "Geändert", type: 'date', editable: false, required: false }];
